import {Schema, NonEmptyString, filter} from 'effect/Schema';

export const Source = NonEmptyString.pipe(
    filter(value => value.includes('/'), {
        identifier: 'Source',
    })
) as unknown as Schema<Source>;
export type Source = import('../src/Source').Source;
